import { useFormContext } from 'react-hook-form';

export const useSetDirtyValue = () => {
  const { setValue } = useFormContext();
  const setDirtyValue = (name: string, value: null | boolean | string) => {
    setValue(name, value, { shouldDirty: true });
  };
  return { setDirtyValue };
};
